import React from 'react';
import { Timer as HeaderTimer } from '@pegasus/ui-headers';
import { CartStatusEnum, Cart, CartType, useTimer } from '@pegasus/cart';

export interface Props {
    cart?: Cart;
    setTimerState: (status: CartStatusEnum) => void;
    onExpiredCart: () => void;
    isFocused: boolean;
    cartLength: number;
}

export const Timer = ({ cart, setTimerState, onExpiredCart, isFocused, cartLength }: Props) => {
    const { counter } = useTimer(cart, {
        onCartExpiresFirstWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_5_MINUTES);
        },
        onCartExpiresSecondWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD);
        },
        onCartExpiresLastWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD);
        },
        onCartExpired: () => {
            setTimerState(CartStatusEnum.CART_EXPIRED);
            onExpiredCart();
        },
    });

    return (
        <HeaderTimer
            timeLeft={counter}
            isFocused={isFocused}
            cartLength={cartLength}
            isCartUnreserved={cart?.cartType === CartType.UNRESERVED}
        />
    );
};
